import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import UserRoute from '../userpage';
import SettingRoute from '../setting';
import { connect } from 'react-redux';
import './index.css';
import Hamburger from '../../components/HamburgerMenu/HamburgerMenu';

export function UserListSettings({ role }) {
  const [value, setValue] = React.useState(0);
  const handleTabs = (event, val) => {
    setValue(val);
  };
  const styles = {
    '& .MuiTabs-scroller': {
      paddingLeft: '20px !important',
    },
    '& .Mui-selected': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '& .MuiTab-root': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '& .MuiTabs-root': {
      paddingLeft: '15px',
    },
  };
  return (
    <div>
      <Hamburger></Hamburger>
      <Tabs sx={styles} value={value} onChange={handleTabs}>
        {role === 1 ? <Tab label="Users   " /> : <Tab label="Settings" />}
        {role === 1 ? <Tab label="Settings" /> : ''}
      </Tabs>
      {role === 1 ? value === 0 && <UserRoute /> : value === 0 && <SettingRoute />}
      {role === 1 && value === 1 && <SettingRoute />}
    </div>
  );
}

const mapStateToProps = (state) => ({
  role: state.app.user.role,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UserListSettings);
